<template>
	<div class="convention-page">
		<!-- 顶部导航 -->
		<van-nav-bar class="nav-bar" :title="$t('concubine.concubine')" />

		<!-- 顶部氛围区 -->
		<div class="hero-section">
			<div class="hero-bg"></div>
			<!-- <div class="hero-content">
				<div class="hero-badge">{{ $t('concubine.concubine') }}</div>
				<div class="hero-title">{{ $t('concubine.concubine') }}</div>
				<div class="hero-subtitle">{{ $t('concubine.city_tip') }}</div>
			</div> -->
		</div>

		<!-- 主体内容 -->
		<div class="content-wrap">
			<div class="panel-card">
				<van-tabs
					v-model="active"
					animated
					sticky
					swipeable
					class="custom-tabs"
					line-width="72px"
				>
					<!-- 城市页 -->
					<van-tab :title="$t('concubine.city')">
						<van-pull-refresh
							v-model="isLoading"
							@refresh="onRefresh"
							pulling-text="Loading"
							loosing-text="Loading"
							loading-text="Loading"
							success-text="Refresh successful"
						>
							<div class="tip-card">
								<div class="tip-icon">❤</div>
								<div class="tip-text">{{ $t("concubine.city_tip") }}</div>
							</div>

							<div class="city-grid">
								<div
									class="mate-card"
									v-for="(val, key) in addlist"
									:key="val.id || key"
									@click="addgo(val)"
								>
									<img class="mate-photo" :src="val.img" alt="" />
									<span class="mate-verified">Verified</span>
									<div class="mate-info">
										<div v-if="companionTag(val)" class="mate-tag">{{ companionTag(val) }}</div>
										<div class="mate-name-line">
											<div class="mate-name">{{ val.name || val.xuanfei_name }}</div>
											<div class="mate-score">
												<svg class="mate-heart" viewBox="0 0 24 24" aria-hidden="true">
													<path d="M12 20s-7-4.4-7-9.1C5 8 6.8 6.2 9.2 6.2c1.3 0 2.4.6 2.8 1.6.4-1 1.5-1.6 2.8-1.6 2.4 0 4.2 1.8 4.2 4.7C19 15.6 12 20 12 20z" fill="currentColor"/>
												</svg>
												<span>{{ companionScore(val) }}</span>
											</div>
										</div>
									</div>
								</div>

								<div v-if="addlist.length === 0" class="empty-box">
									<div class="empty-icon">♡</div>
								</div>
							</div>
						</van-pull-refresh>
					</van-tab>

					<!-- 价格页 -->
					<van-tab :title="$t('concubine.price')">
						<div class="tip-card">
							<div class="tip-icon">✦</div>
							<div class="tip-text">{{ $t("concubine.city_tip") }}</div>
						</div>

						<div class="price-layout">
							<div class="price-main-card">
								<div class="section-head">
									<div class="section-dot"></div>
									<p class="section-title">{{ $t("concubine.pri_resource") }}</p>
								</div>
								<p class="section-content">{{ $t("concubine.pri_obj") }}</p>
							</div>

							<div class="price-main-card">
								<div class="section-head">
									<div class="section-dot"></div>
									<p class="section-title">{{ $t("concubine.pri_service") }}</p>
								</div>
								<p class="section-content">{{ $t("concubine.pric_service_one") }}</p>
								<!-- <p class="section-content">{{ $t("concubine.pric_service_two") }}</p> -->
							</div>

							<!-- <div class="warm-card">
								<div class="warm-title">温馨提示</div>
								<div class="warm-text">
									请根据页面说明选择合适内容，具体展示以实际数据为准。
								</div>
							</div> -->
						</div>
					</van-tab>
				</van-tabs>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			active: 0,
			addlist: [],
			isLoading: false
		};
	},
	methods: {
		addgo(data) {
			if (!localStorage.getItem('token')) {
				this.$router.push({ path: '/Login' });
			} else {
				this.$router.push({ path: '/list?id=' + data.id + '&name=' + data.name });
			}
		},
		getAddress() {
			this.$http({
				method: 'get',
				url: 'xuanfeilist'
			}).then(res => {
				this.addlist = Array.isArray(res.data) ? res.data : [];
			}).finally(() => {
				this.isLoading = false;
			});
		},
		onRefresh() {
			this.getAddress();
		},
		companionTag(item) {
			if (!item || !item.flag) return "";
			return String(item.flag).split(",")[0].trim();
		},
		companionScore(item) {
			const raw = item && item.number !== undefined && item.number !== null && item.number !== ""
				? item.number
				: item && item.dianzan;
			const num = Number(raw);
			if (!Number.isFinite(num)) return raw || "0.0";
			return num.toFixed(1);
		}
	},
	created() {
		this.getAddress();
	}
};
</script>

<style lang="less" scoped>
.convention-page {
	position: absolute !important;
	top: 0;
	left: 0;
	right: 0;
	min-height: 100vh;
	background:
		radial-gradient(circle at top, rgba(255, 214, 230, 0.9) 0%, rgba(255, 245, 248, 0.96) 32%, #fff 68%),
		url('/img/login/login-bg.png');
	background-size: cover;
	background-position: center;
	overflow-x: hidden;
}

/* 顶部导航 */
.nav-bar {
	background: linear-gradient(135deg, #ff7eb3 0%, #ff758c 45%, #ff8fab 100%);
	box-shadow: 0 8px 22px rgba(255, 117, 140, 0.18);
}

::v-deep .van-nav-bar {
	background: transparent !important;
}

::v-deep .van-nav-bar__content {
	height: 92px;
}

::v-deep .van-nav-bar__title {
	max-width: 70%;
	margin: 0 auto;
	color: #ffffff;
	font-size: 34px;
	font-weight: 700;
	letter-spacing: 1px;
}

/* 顶部氛围区 */
.hero-section {
	position: relative;
	padding: 24px 24px 18px;
}

.hero-bg {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 230px;
	background:
		linear-gradient(180deg, rgba(255, 126, 179, 0.22) 0%, rgba(255, 255, 255, 0) 100%);
	pointer-events: none;
}

.hero-content {
	position: relative;
	padding: 10px 8px 0;
}

.hero-badge {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 42px;
	padding: 0 22px;
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.72);
	backdrop-filter: blur(10px);
	color: #ff5f8f;
	font-size: 24px;
	font-weight: 700;
	box-shadow: 0 8px 20px rgba(255, 126, 179, 0.12);
}

.hero-title {
	margin-top: 18px;
	font-size: 46px;
	line-height: 1.2;
	font-weight: 800;
	color: #3f2430;
}

.hero-subtitle {
	margin-top: 10px;
	font-size: 26px;
	line-height: 1.6;
	color: #7f5564;
}

/* 主体区域 */
.content-wrap {
	padding: 0 24px 40px;
}

.panel-card {
	background: rgba(255, 255, 255, 0.88);
	border-radius: 28px;
	box-shadow: 0 14px 40px rgba(205, 92, 122, 0.12);
	backdrop-filter: blur(12px);
	overflow: hidden;
}

/* tabs */
.custom-tabs {
	border-radius: 28px;
	overflow: hidden;
}

::v-deep .van-tabs__wrap {
	height: 96px;
	background: transparent;
}

::v-deep .van-tab {
	font-size: 30px;
	font-weight: 700;
	color: #cc6f8d;
}

::v-deep .van-tab--active {
	color: #ff5f8f;
}

::v-deep .van-tabs__line {
	background: linear-gradient(90deg, #ff8fb1, #ff5f8f);
	height: 6px;
	border-radius: 999px;
}

/* 提示卡 */
.tip-card {
	width: calc(100% - 32px);
	margin: 18px auto 8px;
	padding: 18px 20px;
	background: linear-gradient(135deg, rgba(255, 236, 242, 0.96), rgba(255, 245, 247, 0.96));
	border: 1px solid rgba(255, 160, 190, 0.25);
	border-radius: 20px;
	display: flex;
	align-items: center;
	box-shadow: 0 8px 18px rgba(255, 130, 165, 0.08);
}

.tip-icon {
	width: 44px;
	height: 44px;
	border-radius: 50%;
	background: linear-gradient(135deg, #ff8fb1, #ff6f98);
	color: #fff;
	font-size: 22px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	margin-right: 14px;
}

.tip-text {
	flex: 1;
	color: #7d4a5d;
	font-size: 24px;
	line-height: 1.6;
}

/* 城市宫格 */
.city-grid {
	width: calc(100% - 32px);
	margin: 0 auto;
	padding: 14px 0 34px;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 18px;
}

.city-card {
	position: relative;
	cursor: pointer;
}

.city-image-wrap {
	position: relative;
	width: 100%;
	height: 58vw;
	max-height: 420px;
	min-height: 250px;
	border-radius: 24px;
	overflow: hidden;
	background: #f8f8f8;
	box-shadow: 0 10px 26px rgba(214, 113, 144, 0.16);
	transform: translateY(0);
	transition: all 0.25s ease;
}

.city-card:active .city-image-wrap {
	transform: scale(0.985);
}

.city-image {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}

.image-mask {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	height: 46%;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(35, 14, 22, 0.72) 100%);
}

.city-info {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	padding: 18px 16px 16px;
	color: #fff;
}

.city-name {
	font-size: 28px;
	font-weight: 700;
	line-height: 1.3;
	text-shadow: 0 2px 6px rgba(0, 0, 0, 0.22);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.city-action {
	margin-top: 8px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 34px;
	padding: 0 16px;
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.2);
	backdrop-filter: blur(8px);
	font-size: 20px;
	color: rgba(255, 255, 255, 0.96);
}

/* 空状态 */
.empty-box {
	grid-column: 1 / -1;
	padding: 80px 20px;
	text-align: center;
}

.empty-icon {
	font-size: 50px;
	color: #ff9ab8;
}

.empty-text {
	margin-top: 12px;
	font-size: 24px;
	color: #a07a87;
}

/* 价格说明 */
.price-layout {
	width: calc(100% - 32px);
	margin: 0 auto;
	padding: 14px 0 40px;
}

.price-main-card {
	background: linear-gradient(180deg, #ffffff 0%, #fff8fa 100%);
	border: 1px solid rgba(255, 179, 204, 0.28);
	border-radius: 24px;
	padding: 24px 22px;
	box-shadow: 0 10px 24px rgba(236, 134, 164, 0.08);
	margin-bottom: 18px;
}

.section-head {
	display: flex;
	align-items: center;
	margin-bottom: 16px;
}

.section-dot {
	width: 16px;
	height: 16px;
	border-radius: 50%;
	background: linear-gradient(135deg, #ff8fb1, #ff5f8f);
	margin-right: 12px;
	flex-shrink: 0;
}

.section-title {
	margin: 0;
	color: #d84f7d;
	font-size: 30px;
	font-weight: 700;
	line-height: 1.4;
}

.section-content {
	margin: 0;
	font-size: 25px;
	line-height: 1.8;
	color: #5d4650;
	word-break: break-word;
}

.warm-card {
	padding: 22px 22px 24px;
	border-radius: 22px;
	background: linear-gradient(135deg, rgba(255, 237, 242, 0.92), rgba(255, 248, 250, 0.95));
	border: 1px dashed rgba(255, 150, 180, 0.4);
}

.warm-title {
	font-size: 28px;
	font-weight: 700;
	color: #d95f88;
	margin-bottom: 10px;
}

.warm-text {
	font-size: 24px;
	line-height: 1.8;
	color: #7d616b;
}

/* 兼容原项目一些默认样式 */
.van-sidebar {
	width: 180px;
}

::v-deep .van-row--flex {
	height: 80px;
	line-height: 80px;
}

::v-deep .van-cell {
	padding: 30px 22px;
	font-size: 30px;
	line-height: 30px;
}

/* 小屏优化 */
@media (max-width: 420px) {
	.hero-title {
		font-size: 40px;
	}

	.hero-subtitle {
		font-size: 24px;
	}

	.city-image-wrap {
		height: 60vw;
		min-height: 220px;
	}

	.city-name {
		font-size: 26px;
	}

	.section-title {
		font-size: 28px;
	}

	.section-content {
		font-size: 24px;
	}
}
</style>

<style lang="less" scoped>
.convention-page {
	position: relative !important;
	min-height: 100vh;
	padding-bottom: calc(88PX + env(safe-area-inset-bottom));
	background:
		radial-gradient(120% 42% at 50% -8%, rgba(148, 98, 36, 0.32), transparent 56%),
		radial-gradient(70% 30% at 100% 18%, rgba(112, 36, 72, 0.2), transparent 62%),
		linear-gradient(180deg, #1a140f 0%, #100d13 36%, #0c0a10 100%);
	color: #efe6d6;
	font-family: "Plus Jakarta Sans", "PingFang SC", "Microsoft YaHei", sans-serif;
}

.hero-section {
	display: none;
}

.nav-bar,
::v-deep .van-nav-bar {
	background: transparent !important;
	box-shadow: none;
}

::v-deep .van-nav-bar__content {
	height: 52PX;
}

::v-deep .van-nav-bar__title {
	color: #f3d27a !important;
	font-size: 18PX !important;
	font-weight: 650;
}

.content-wrap {
	padding: 0 12PX 16PX;
}

.panel-card {
	background: transparent;
	border-radius: 0;
	box-shadow: none;
	backdrop-filter: none;
	overflow: visible;
}

.custom-tabs {
	overflow: visible;
}

::v-deep .van-tabs__wrap,
::v-deep .van-sticky,
::v-deep .van-sticky--fixed {
	height: auto;
	min-height: 52PX;
	overflow: visible;
	background: #120e14;
}

::v-deep .van-tabs__nav {
	height: 52PX;
	background: transparent;
}

::v-deep .van-tab {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 52PX;
	padding: 10PX 6PX;
	overflow: visible;
	line-height: 1.4;
	color: #9a907c;
	font-size: 15PX;
	font-weight: 650;
}

::v-deep .van-tab__text {
	overflow: visible;
	line-height: 1.4;
}

::v-deep .van-tab--active {
	color: #f3d27a;
}

::v-deep .van-tabs__line {
	height: 2PX;
	background: #e7c56a;
}

.tip-card {
	display: flex;
	align-items: flex-start;
	gap: 8PX;
	margin: 10PX 2PX 12PX;
	padding: 10PX 12PX;
	border: 1PX solid rgba(244, 216, 131, 0.16);
	border-radius: 8PX;
	background: rgba(255, 244, 214, 0.06);
	box-shadow: inset 0 1PX 0 rgba(255, 236, 196, 0.08);
}

.tip-icon {
	color: #e7c56a;
	font-size: 14PX;
	line-height: 1.4;
}

.tip-text {
	color: rgba(249, 234, 184, 0.78);
	font-size: 12PX;
	line-height: 1.5;
}

.city-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10PX;
}

.city-image-wrap {
	height: 210PX;
	overflow: hidden;
	border: 1PX solid rgba(244, 216, 131, 0.28);
	border-radius: 8PX;
}

.city-image {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.city-name {
	color: #fff;
	font-size: 14PX;
	line-height: 1.45;
	font-weight: 700;
}

.city-action {
	margin-top: 4PX;
	line-height: 1.4;
	color: #f3d27a;
	font-size: 11PX;
}

.mate-card {
	position: relative;
	overflow: hidden;
	height: 236PX;
	border: 1PX solid rgba(244, 216, 131, 0.34);
	border-radius: 8PX;
	background: #140f18;
}

.mate-photo {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.mate-verified {
	position: absolute;
	top: 8PX;
	right: 8PX;
	z-index: 1;
	padding: 2PX 8PX;
	border-radius: 999PX;
	background: linear-gradient(135deg, #fff4d2 0%, #e7c56a 100%);
	color: #4a3410;
	font-size: 10PX;
	font-weight: 700;
	line-height: 1.45;
}

.mate-info {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1;
	padding: 36PX 10PX 10PX;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.82) 72%);
}

.mate-tag {
	display: inline-block;
	max-width: 100%;
	padding: 1PX 6PX;
	overflow: hidden;
	border: 1PX solid rgba(246, 214, 122, 0.85);
	border-radius: 999PX;
	color: #f8e7b0;
	font-size: 10PX;
	font-weight: 700;
	line-height: 1.35;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.mate-name {
	margin-top: 4PX;
	min-width: 0;
	flex: 1;
	overflow: hidden;
	color: #fff;
	font-size: 14PX;
	font-weight: 700;
	line-height: 1.35;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.mate-name-line {
	display: flex;
	align-items: center;
	gap: 6PX;
	margin-top: 4PX;
}

.mate-name-line .mate-name {
	margin-top: 0;
}

.mate-score {
	display: flex;
	align-items: center;
	flex: none;
	gap: 4PX;
	color: #ff6d8f;
	font-size: 12PX;
	font-weight: 700;
	line-height: 1;
}

.mate-heart {
	width: 12PX;
	height: 12PX;
	flex: none;
}

.price-main-card {
	margin-bottom: 10PX;
	padding: 14PX 12PX;
	border: 1PX solid rgba(244, 216, 131, 0.16);
	border-radius: 8PX;
	background: linear-gradient(180deg, rgba(255, 244, 214, 0.075), rgba(18, 14, 22, 0.4));
	box-shadow: 0 10PX 22PX rgba(0, 0, 0, 0.24), inset 0 1PX 0 rgba(255, 236, 196, 0.08);
}

.section-dot {
	width: 3PX;
	height: 14PX;
	border-radius: 99PX;
	background: linear-gradient(180deg, #fff1c8, #c9963a);
}

.section-title {
	color: #f9eab8;
	font-size: 15PX;
}

.section-content {
	color: rgba(255, 255, 255, 0.72);
	font-size: 13PX;
	line-height: 1.6;
}

.empty-box {
	color: rgba(249, 234, 184, 0.7);
}

@media (min-width: 768px) {
	html.pc-shell .convention-page {
		min-height: 0 !important;
		padding-bottom: 120PX !important;
	}

	html.pc-shell .content-wrap {
		padding: 0 12PX 20PX !important;
	}

	html.pc-shell .panel-card,
	html.pc-shell .custom-tabs {
		width: 100%;
		border-radius: 0 !important;
		overflow: visible !important;
	}

	html.pc-shell .tip-card {
		width: auto !important;
		margin: 12PX 0 !important;
		padding: 12PX !important;
		align-items: center !important;
		gap: 10PX !important;
	}

	html.pc-shell .tip-icon {
		width: 28PX !important;
		height: 28PX !important;
		margin: 0 !important;
		border-radius: 8PX !important;
		background: rgba(243, 210, 122, 0.16) !important;
		color: #f3d27a !important;
		font-size: 14PX !important;
		line-height: 1 !important;
	}

	html.pc-shell .tip-text {
		font-size: 13PX !important;
		line-height: 1.5 !important;
	}

	html.pc-shell .city-grid,
	html.pc-shell .price-layout {
		width: auto !important;
		margin: 0 !important;
		padding: 0 !important;
	}

	html.pc-shell .city-grid {
		gap: 10PX !important;
		padding-bottom: 8PX !important;
	}

	html.pc-shell .mate-card {
		height: 248PX !important;
	}
}
</style>
